function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import request from "../../../../utils/request";
import { context, updateContextState } from "../../wr-context";
import { makeAction, WorkflowUnit } from "./../workflow";
import { fetchProductsByCatalogId } from "../../../../modules/product/product-requests";
import { fetchCompanySettingsRequest } from "../../../../modules/settings/settings-requests";
import { isAnalyticsEnabled, startAnalyticsPageListener } from "../../../../modules/analytics";
import mixpanel from "mixpanel-browser";
export var INITIALIZATION_KEY = "initialization";
export var collectSfParams = makeAction("collectSfParams", function(next) {
    var wrBox = window.wrBox;
    if (wrBox) {
        context.constants.sfData = wrBox;
    }
    next();
});
export var fetchExistingProposal = makeAction("fetchExistingProposal", function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
        var externalRefKey, externalRef, conditions, body, proposal;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    externalRefKey = "settings.opportunityId";
                    externalRef = context.constants.sfData.opportunityId;
                    if (externalRef) {
                        _ctx.next = 5;
                        break;
                    }
                    next();
                    return _ctx.abrupt("return");
                case 5:
                    conditions = [
                        {
                            field: externalRefKey,
                            comparator: "eq",
                            value: externalRef
                        }, 
                    ];
                    body = JSON.stringify({
                        data: {
                            companyId: context.constants.client.companyId,
                            limit: 1,
                            offset: 0,
                            query: {
                                groupType: "and",
                                conditions: conditions
                            },
                            sortField: "settings.submittedAt",
                            sortOrder: "desc"
                        }
                    });
                    _ctx.next = 9;
                    return request({
                        url: "".concat(context.constants.appHost, "/api/v1/documents/advanced-search"),
                        method: "POST",
                        body: body
                    });
                case 9:
                    proposal = _ctx.sent;
                    updateContextState(function(state) {
                        state.existingProposal = proposal.data[0];
                    });
                    next();
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(next) {
        return _ref.apply(this, arguments);
    };
}());
export var fetchCatalog = makeAction("fetchCatalog", function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
        var _client, catalogIds, addOnCatalogId, fetchCatalogRequest, fetchAddonCatalogRequest;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _client = context.constants.client, catalogIds = _client.catalogIds, addOnCatalogId = _client.addOnCatalogId;
                    fetchCatalogRequest = fetchProductsByCatalogId(catalogIds[0]);
                    if (!fetchCatalogRequest.url) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 5;
                    return request({
                        url: fetchCatalogRequest.url
                    }).then(fetchCatalogRequest.then);
                case 5:
                    if (!addOnCatalogId) {
                        _ctx.next = 10;
                        break;
                    }
                    fetchAddonCatalogRequest = fetchProductsByCatalogId(addOnCatalogId);
                    if (!fetchAddonCatalogRequest.url) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 10;
                    return request({
                        url: fetchAddonCatalogRequest.url
                    }).then(fetchAddonCatalogRequest.then);
                case 10:
                    next();
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(next) {
        return _ref.apply(this, arguments);
    };
}());
export var restoreCart = makeAction("restoreCart", function(next) {
    updateContextState(function(state) {
        var ref;
        var addOnCatalogId = context.constants.client.addOnCatalogId;
        var addOnCatalog = context.state.catalogs.find(function(catalog) {
            return catalog.id === addOnCatalogId;
        });
        state.addOnItems = addOnCatalog === null || addOnCatalog === void 0 ? void 0 : addOnCatalog.contents.items;
        var regions = new Set();
        var scanPhaseTreeRecursive = function(parentPhase, cb) {
            var ref;
            cb(parentPhase);
            parentPhase === null || parentPhase === void 0 ? void 0 : (ref = parentPhase.children) === null || ref === void 0 ? void 0 : ref.forEach(function(child) {
                return scanPhaseTreeRecursive(child, cb);
            });
        };
        if (state.addOnItems) {
            state.addOnItems.forEach(function(item) {
                var row = item.rows.find(function(r) {
                    return r.rowType === "component:phase";
                });
                if (!row) return;
                scanPhaseTreeRecursive(row.parsedControl, function(phase) {
                    var ref, ref1;
                    (ref1 = phase === null || phase === void 0 ? void 0 : (ref = phase.rate) === null || ref === void 0 ? void 0 : ref.settings.overrides) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(ovr) {
                        regions.add(ovr.key);
                    });
                });
            });
        }
        // Store regions
        state.regions = _toConsumableArray(regions);
        loadProposalIntoState(state, state.existingProposal, addOnCatalog === null || addOnCatalog === void 0 ? void 0 : (ref = addOnCatalog.contents) === null || ref === void 0 ? void 0 : ref.items, {
            initial: true
        });
    });
    next();
});
export var fetchCompanyDocumentTemplates = makeAction("fetchCompanyDocumentTemplates", function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return request({
                        url: "".concat(context.constants.appHost, "/api/v1/templates/search?companyId=").concat(context.constants.client.companyId)
                    });
                case 2:
                    data = _ctx.sent.data;
                    updateContextState(function(state) {
                        state.templates = data;
                    });
                    next();
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(next) {
        return _ref.apply(this, arguments);
    };
}());
var fetchCompanySettings = makeAction("fetchCompanySettings", function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
        var ref, companySettingsData, companySettings;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return request(fetchCompanySettingsRequest(context.constants.client.companyId));
                case 2:
                    ref = _ctx.sent;
                    companySettingsData = ref.data;
                    companySettings = companySettingsData.map(function(setting) {
                        return _defineProperty({}, setting.settingKey, setting.settingValue);
                    }).reduce(function(acc, setting) {
                        return _objectSpread({}, acc, setting);
                    }, {});
                    updateContextState(function(state) {
                        state.companySettings = companySettings;
                    });
                    next();
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(next) {
        return _ref.apply(this, arguments);
    };
}());
export var initializeAnalytics = makeAction("initializeAnalytics", function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(next) {
        var ref, ref1, ref2;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAnalyticsEnabled() && process.env.REACT_APP_MIXPANEL_TOKEN) {
                        ;
                        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
                            debug: true
                        });
                        mixpanel.identify(((ref = context.state.user) === null || ref === void 0 ? void 0 : ref.externalId) || ((ref1 = context.state.user) === null || ref1 === void 0 ? void 0 : ref1.id) || ((ref2 = context.state.user) === null || ref2 === void 0 ? void 0 : ref2.email));
                        startAnalyticsPageListener();
                    }
                    next();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(next) {
        return _ref.apply(this, arguments);
    };
}());
export var defaultActions = [
    fetchCompanySettings,
    fetchCatalog,
    fetchCompanyDocumentTemplates,
    fetchExistingProposal,
    restoreCart,
    initializeAnalytics, 
];
export var createInitializationUnit = function(options) {
    var ref;
    var initializationActions = (ref = options === null || options === void 0 ? void 0 : options.actions) !== null && ref !== void 0 ? ref : defaultActions;
    return new WorkflowUnit(INITIALIZATION_KEY, initializationActions);
};
export var getAddonsFromCartItems = function(cart) {
    var selectedAddons = [];
    cart.forEach(function(cartItem) {
        if (cartItem.selectedAddons) {
            selectedAddons = _toConsumableArray(selectedAddons).concat(_toConsumableArray(cartItem.selectedAddons));
        }
    });
    return selectedAddons;
};
export var loadProposalIntoState = function(state, proposal, items) {
    var initial = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        initial: false
    }).initial;
    if (!proposal) {
        return;
    }
    var ref = (proposal === null || proposal === void 0 ? void 0 : proposal.settings) || {}, transientState = ref.transientState, phasesConfig = ref.phasesConfig;
    // Restore transient catalog state
    if (initial && transientState) {
        var history = transientState.history;
        // Replace current route
        if (history && history.location.pathname) {
            context.history.replace(history.location.pathname, history.location.state);
        }
        [
            "transientProductValues",
            "chosenTemplate",
            "chosenCurrency"
        ].forEach(function(value) {
            var _$state = transientState[value];
            if (_$state) {
                context.state[value] = _$state;
            }
        });
    }
    // Restore phasesConfig
    if (phasesConfig) {
        state.phasesConfig = phasesConfig;
    }
    // Restore cart
    state.cart = ((proposal === null || proposal === void 0 ? void 0 : proposal.settings.cart) || [])// Filter that are no longer present items
    .filter(function(product) {
        var item = items === null || items === void 0 ? void 0 : items.find(function(item) {
            return item.id === product.id;
        });
        return Boolean(item);
    }).map(function(product) {
        var item = items === null || items === void 0 ? void 0 : items.find(function(item) {
            return item.id === product.id;
        });
        var itemObj = {
            id: item.id,
            cartId: product.cartId,
            description: item.description,
            name: item.name,
            rows: item.rows,
            values: product.values,
            selectedAddons: product.selectedAddons || [],
            price: product.price,
            categories: item.categories,
            createdAt: item.createdAt,
            updatedAt: item.updatedAt,
            createdBy: item.createdBy
        };
        return itemObj;
    });
    state.selectedAddons = getAddonsFromCartItems(state.cart);
};
var InitializationUnit = createInitializationUnit();
export default InitializationUnit;
